import script from "./system-parameter.vue?vue&type=script&setup=true&lang=js"
export * from "./system-parameter.vue?vue&type=script&setup=true&lang=js"

import "./system-parameter.vue?vue&type=style&index=0&id=6f6a9a30&lang=scss&scoped=true"
import "./system-parameter.vue?vue&type=style&index=1&id=6f6a9a30&lang=css"

import exportComponent from "E:\\maoqiaoProjectFile\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f6a9a30"]])

export default __exports__